import React from 'react'
import MaterialSymbol from '../material-symbol'

const Description = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="description" {...props} />
))

Description.displayName = 'Description'

export default Description
